var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-item',{class:_vm.slider_item_class,attrs:{"tag":"label"}},[_c('q-item-section',[_c('q-item-label',[_vm._v(_vm._s(_vm.item.text))])],1),_c('q-item-section',{attrs:{"avatar":""}},[_c('q-toggle',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }